<div style="display: block;">
  <h6 class="text-center">{{title}}</h6>
  <div class="bg-white">
    <canvas baseChart [style.height]="height" [data]="lineChartData" [labels]="lineChartLabels" [options]="{linetension: 0}"
      [legend]="lineChartLegend" [type]="lineChartType">
    </canvas>
  </div>
</div>